module.exports = __webpack_public_path__ + "img/frontend_base_agro.80419c7d.jpg";